/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/CardLogic/IPlayValuesDailyAuthority',[], function () {
    "use strict";

    var IPlayValuesDailyAuthority =  function () {
        //this.NumberPlayed = 0;
        //this.NumberToPlay = 0;
        //this.Value = null
        this.SuppressClearHintsOnMouseDown = true;
    };


    return IPlayValuesDailyAuthority;

});
